import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(values: any, args?: any): any {
    const regExp1 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    const regExp2 = '[a-zA-Z0-9?!"·$%&/()=?¿|@#~€¬^*¨Ç;:_]*';
    const regExp = new RegExp(regExp1 + args[1] + regExp2, 'i');
    if (!args[1]) {
      args[1] = '';
    }
    if (values) {
      values = values.filter(
        (value) => {
          if (args[0][0]) {
            for (const arg of args[0]) {
              if ( regExp.test( eval('value[arg]') ) ) {
                return value;
              }
            }
          } else {
            if ( regExp.test( eval('value') ) ) {
              return value;
            }
          }
        }
      );
    }
    return values;
  }

}